module.exports = "/images/vendor/flag-icon-css/flags/4x3/et.svg?2ebb0d3d6e63baf78a33bca7e1ae9326";